import $ from 'jquery';
import store from 'store2'

export default function(url,data,done){

  var s = store.namespace('omb')

  var serverUrl = s('dataServer')

  $.ajax({
    url: serverUrl + url,
    type: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    contentType: "application/json",
    data: JSON.stringify(data)
  })
  .done(function(result, textStatus, jqXHR) {
    if(result.error){
      done(result)
    } else {
      done(null,result);
    }
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    done({error: 'post failed'});
  })

}



// WEBPACK FOOTER //
// ./src/client/lib/post.js